import { ClipBoardTooltip } from "@/components/ClipBoardTooltip.tsx";
import { ContentPane } from "@/components/ContentPane.tsx";
import { ResourceWithIcon } from "@/components/ResourceWithIcon.tsx";
import { SectionHeader } from "@/components/SectionHeader.tsx";
import { WTable, WTableBody } from "@/components/table/WTable.tsx";
import type { VpcWithType } from "@/modules/network/vpc/vpcApi.ts";
import type { ManagedServiceWithAssigned } from "@/modules/services/joinAssignedQuery.ts";
import { Trans } from "@lingui/react/macro";

export function NetworkingContent({ vpc, service }: { vpc: VpcWithType; service: ManagedServiceWithAssigned }) {
    const { name, subnet } = vpc;
    const { properties } = service;
    return (
        <ContentPane className="VStack gap-4">
            <SectionHeader
                title={<Trans>Private network</Trans>}
                description={
                    <Trans>
                        This service is accessible only by resources in the same VPC network using these private
                        addresses.
                    </Trans>
                }
            />

            <WTable>
                <thead>
                    <tr>
                        <th>
                            <Trans>Private IPv4</Trans>
                        </th>
                        <th>
                            <Trans>VPC network</Trans>
                        </th>
                        <th>
                            <Trans>VPC IP range</Trans>
                        </th>
                    </tr>
                </thead>
                <WTableBody>
                    <tr>
                        <td>
                            <ClipBoardTooltip>
                                {("service_ip" in properties ? properties.service_ip : undefined) ?? ""}
                            </ClipBoardTooltip>
                        </td>
                        <td>
                            <ResourceWithIcon type="vpc" title={name} />
                        </td>
                        <td>
                            <ClipBoardTooltip>{subnet}</ClipBoardTooltip>
                        </td>
                    </tr>
                </WTableBody>
            </WTable>
        </ContentPane>
    );
}
